import { useQuery } from "react-query";
import { pos } from "@/platform";
import { useAuthUser } from "@/context/auth/AuthContext";

export const TERMINAL_DEL_EQUIPO_QUERY_KEY = "caja-terminal-del-equipo";

/**
 * La terminal que este equipo guarda para el negocio de la sesión (#344 AC-1).
 * Sale del almacén local de la caja, no del servidor: en la web no hay.
 */
export function useTerminalDelEquipo() {
  const businessId = useAuthUser()?.businessId as string | undefined;

  const query = useQuery(
    [TERMINAL_DEL_EQUIPO_QUERY_KEY, businessId],
    () => pos.getTerminal(businessId as string),
    {
      enabled: pos.isAvailable && !!businessId,
      // Es un archivo local: no hay nada que refrescar al volver a la ventana.
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
    }
  );

  return {
    disponible: pos.isAvailable,
    terminal: query.data ?? null,
    cargando: pos.isAvailable && !!businessId && query.isLoading,
    error: query.error as Error | null,
  };
}
